import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Empresa } from '../../../models/empresa.model';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-empresa",
    templateUrl: "./empresa.component.html",
    styleUrls: ["./empresa.component.css"],
    providers: [UserService, FormService]
})

export class EmpresaComponent {

    @ViewChild('openModal') openModal: TemplateRef<any>;
    public isNatural;
    public rut_emp
    public mail_emp
    public invalidRut: Boolean;
    public empresa
    public rows = [];
    public actualRow;
    public form;
    public formRow;
    public formulario;

    public filteredOptions;
    public nombreComuna = new FormControl('', [Validators.required]);
    options = []
    public selectedEmp: number = null;

    public matcher = new FormService();

    public form251 = false;
    public form252 = false;
    public form253 = false;
    public form254 = false;
    public form255 = false;

    public form131 = false;
    public form132 = false;
    public form133 = false;

    constructor(private fb: FormBuilder, private _userService: UserService, rutValidator: RutValidator,
        private dialog: MatDialog, private spinner: NgxSpinnerService) {

        this.formulario = localStorage.getItem("form")


        if (this.formulario == "2-5.1") {
            this.form251 = true;
        }
        if (this.formulario == "2-5.2") {
            this.form252 = true;
        }
        if (this.formulario == "2-5.3") {
            this.form253 = true;
        }
        if (this.formulario == "2-5.4") {
            this.form254 = true;
        }
        if (this.formulario == "2-5.5") {
            this.form255 = true;
        }

        if (this.formulario == "1-3.1") {
            this.form131 = true;
        }
        if (this.formulario == "1-3.2") {
            this.form132 = true;
        }
        if (this.formulario == "1-3.3") {
            this.form133 = true;
        }

        

        this.rut_emp = this.fb.group({
            rut: ['', [Validators.required, rutValidator]]
        })
        this.form = new FormGroup({
            mantieneProfesionales: new FormControl(''),
            adjuntaComunicacion: new FormControl('')
        })

        this.mail_emp = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        })

        if (!JSON.parse(localStorage.getItem("empresas"))) {
            localStorage.setItem("empresas", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("empresas"));
        }
        this.invalidRut = true;
        this.empresa = { rut: '', nombre: '', adjuntaComunicacion:'', mantieneProfesionales:'', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
    }

    regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    ngOnInit() {

    }

    ngAfterContentInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }

    get_empresa(rut) {
        this.spinner.show();

        var rut_orig = rut;
        var dv;

        if (rut.includes("-")) {
            var fullRut = rut.split("-");
            rut = fullRut[0];
            dv = fullRut[1];
        } else {
            dv = rut
            rut = rut.toString();
            rut = rut.substring(0, rut.length - 1);
            dv = dv.slice(-1);
        }



        if (rut >= 50000000) {
            this.isNatural = false;
        }
        else {
            this.isNatural = true;
        }


        this.cleanData();
        this._userService.getEmpresa(rut_orig).subscribe(

            response => {
                if (response.message) {
                    this.empresa.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);

                } else {
                    this.empresa.rut = response.rut ? response.rut : '';
                    this.empresa.nombre = response.nombre ? response.nombre : '';
                    this.empresa.direccion = response.direccion ? response.direccion : '';
                    this.empresa.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.empresa.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.empresa.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.empresa.comuna = response.comuna ? response.comuna : '';
                    this.empresa.fono = response.fono ? response.fono : '';
                    this.empresa.fax = response.fono ? response.fax : '';
                    this.empresa.mail = response.mail ? response.mail : '';
                    this.empresa.recordId = response.recordId ? response.recordId : '';
                    // this.empresa.mantieneProfesionales=  this.form.value.mantieneProfesionales ? "mantieneProfesionales" : "noMantieneProfesionales",
                    // this.empresa.adjuntaComunicacion=  this.form.value.adjuntaComunicacion ? "adjuntaComunicacion" : "noAdjuntaComunicacion"
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }





    cleanData() {
        this.empresa = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
        this.rut_emp.reset()
    }

    update_empresa(rut, id) {
        this.get_empresa(rut);
        this.selectedEmp = id;
    }

    saveEmpresa() {
        this.spinner.show();
        //por si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {
            if (this.empresa.rut == this.rows[x].rut) {
                this.delete_empresa(x);
            }
        }

        //elimina fila cuando la editan
        /*if (this.selectedEmp != null) {
            this.delete_empresa(this.selectedEmp);
            this.selectedEmp = null;
        }*/

        this._userService.saveEmpresa(this.empresa).subscribe(
            response => {
                this.spinner.hide();

                if (response.update || response.save) {
                    $("#emp_modal").modal("hide");
                    this.actualRow = localStorage.getItem("empresas");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.empresa.rut,
                        nombre: this.empresa.nombre,
                        direccion: this.empresa.direccion,
                        direccion_num: this.empresa.direccion_num,
                        direccion_complemento: this.empresa.direccion_complemento,
                        direccion_completa: this.empresa.direccion_completa,
                        comuna: this.empresa.comuna,
                        fono: this.empresa.fono,
                        fax: this.empresa.fax,
                        mail: this.empresa.mail,
                        mantieneProfesionales: this.form.value.mantieneProfesionales ? "mantieneProfesionales" : "noMantieneProfesionales",
                        adjuntaComunicacion: this.form.value.adjuntaComunicacion ? "adjuntaComunicacion" : "noAdjuntaComunicacion"

                    })

                    localStorage.setItem("empresas", JSON.stringify(this.rows));
                    this.empresa = { rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
                    this.rut_emp.reset();
                    this.dialog.closeAll();

                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }
    delete_empresa(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("empresas", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('empresas'));
            }
        }
    }

    getComunas() {

        if (JSON.parse(localStorage.getItem("comunas"))) {
            if (JSON.parse(localStorage.getItem("comunas")).length > 0) {
                this.options = JSON.parse(localStorage.getItem('comunas'));

            } else {
                this.options = []
            }
        }

        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );

    }


    add_antecedentesEmpresa() {
        this.formRow = {
            mantieneProfesionales: this.form.value.mantieneProfesionales ? "mantieneProfesionales" : "noMantieneProfesionales",
            adjuntaComunicacion: this.form.value.adjuntaComunicacion ? "adjuntaComunicacion" : "noAdjuntaComunicacion"
        }
    
        if (this.rows.length != 0) {
            this.rows[0].mantieneProfesionales = this.form.value.mantieneProfesionales ? "mantieneProfesionales" : "noMantieneProfesionales";
            this.rows[0].adjuntaComunicacion = this.form.value.adjuntaComunicacion ? "adjuntaComunicacion" : "noAdjuntaComunicacion";
    
            try {
                localStorage.setItem("empresas", JSON.stringify(this.rows));
                console.log("Datos guardados en localStorage exitosamente");
            } catch (error) {
                console.error("Error al guardar los datos en localStorage:", error);
            }
        }
    }
    
}